import React, { useState } from 'react'

import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import SimpleInput from 'components/common/SimpleInput/SimpleInput'
import { THEME_DARK } from 'constants.js'
import { isMobile } from 'utils'
import { useStyles } from './styles'

export const FriendReferral = ({ priorityListUser, artistId, artistName }) => {
    const [copySuccessful, setCopySuccessful] = useState(false)
    const classes = useStyles()
    const link = `${window.location.protocol}//${window.location.host}/priority-list/${artistId}?ref_code=${priorityListUser.referralCode}`
    const formData = {
        link,
    }
    const message = `Join me on the Priority List for ${artistName}'s exclusive event`

    const shareViaSMS = () => {
        if (isMobile('ios')) {
            window.location = `sms:?&body=${message}: ${link}`
        } else if (isMobile()) {
            window.location = `sms:?body=${message}: ${link}`
        }
    }

    const getShareButtonLabel = () => {
        if (isMobile()) return 'Share'
        else if (copySuccessful) return 'Copied!'
        else return 'Copy Link'
    }

    const copyLinkToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(link)
            setCopySuccessful(true)
        } catch (err) {
            setCopySuccessful(false)
        }
    }

    /**
     * On mobile, attempt to use the WebShare API to display a native share menu. Fallback to copying to clipboard + SMS
     * On desktop, copy the link to the clipboard instead.
     * The mobile share menu has a copy to clipboard option, so there's no need to copy the link preemptively, which
     * would cause a bug in iOS 13 where the share menu would get closed by the action of copying to clipboard.
     */
    const shareHandler = () => {
        if (isMobile()) {
            if (navigator.share) {
                try {
                    navigator.share({
                        title: 'Novel Invitation',
                        text: message,
                        url: link,
                    })
                } catch (err) {
                    shareViaSMS()
                }
            } else {
                copyLinkToClipboard()
                shareViaSMS()
            }
        } else if (navigator.clipboard) {
            copyLinkToClipboard()
        }
    }

    return (
        <div className={classes.container}>
            <p className={classes.headline}>Nice! You're on the priority list.</p>
            <p className={classes.headlineDesc}>
                We’ll send show details to your email. Keep an eye out for updates. Oh, and get pumped.
            </p>

            <p className={classes.disclaimer}>
                Be a hero. Send the link to your friends below so they don’t miss out on Priority List spots.
            </p>

            <form className={classes.formInline} onSubmit={shareHandler}>
                <SimpleInput
                    value={formData.link}
                    label=""
                    className={classes.formCtrlInline}
                    themeColor={THEME_DARK}
                    readOnly={true}
                />
                <CallToActionButton onClick={shareHandler} type="white" display="inline" text={getShareButtonLabel()} />
                <input style={{ display: 'none' }} type="submit" />
            </form>
        </div>
    )
}

export default React.memo(FriendReferral)
